import React, { useEffect } from "react";
import PageShell from "../components/PageShell";
import { setMeta } from "../lib/seo";

export default function Contact() {
  useEffect(() => {
    setMeta({
      title: "Contact Culinera",
      description:
        "Reach Culinera at hello@culinera.ca for listing corrections, itinerary help, suggestions, or privacy requests. We read every message.",
      canonical: "https://culinera.ca/contact",
    });
  }, []);

  return (
    <PageShell testid="contact-page">
      <article className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-4xl font-bold text-gray-900 mb-6">Contact Culinera</h1>
        <p className="text-lg text-gray-700 mb-6">
          The fastest way to reach us is email:{" "}
          <a className="text-teal-600 font-semibold hover:underline" href="mailto:hello@culinera.ca" data-testid="contact-email-link">hello@culinera.ca</a>
        </p>
        <p className="text-gray-700 mb-4">We read every message. Write to us about:</p>
        <ul className="list-disc pl-6 space-y-2 text-gray-700">
          <li><strong>A listing correction</strong> — a closed restaurant, wrong hours, a wrong city, or a duplicate listing. Tell us the listing name and what is wrong and we will fix it.</li>
          <li><strong>Itinerary help</strong> — a problem with the trip planner or an itinerary you received.</li>
          <li><strong>A suggestion</strong> — a place we should cover, or a guide topic you want.</li>
          <li><strong>Privacy</strong> — a request to see or delete your information.</li>
        </ul>
        <p className="text-gray-700 mt-6">
          Please include the page URL when you report a problem with a specific listing or page — it helps us fix it faster.
        </p>

        <div className="mt-10">
          <a href="mailto:hello@culinera.ca" className="bg-teal-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-teal-700 transition-colors">Email hello@culinera.ca</a>
        </div>
      </article>
    </PageShell>
  );
}
